import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import getDisplayValue from 'app/shared-components/util/getDisplayValue';
import getListDisplayValue from 'app/shared-components/util/getListDisplayValue';
import genders from 'app/shared-components/controls/genders.json';
import treatmentLocations from 'app/shared-components/controls/treatmentLocations.json';
import riskBehaviors from 'app/shared-components/controls/riskBehaviors.json';
import familySupport from 'app/shared-components/controls/familySupport.json';
import providerAges from 'app/shared-components/controls/providerAges.json';
import conditions from 'app/shared-components/controls/conditions.json';
import clientTypes from 'app/shared-components/controls/clientTypesSingular.json';
import insurance from 'app/shared-components/controls/insurance.json';
import types from 'app/shared-components/controls/referralTypes.json';
import availabilityWindows from 'app/shared-components/controls/availabilityWindows.json';
import urgencyTypes from 'app/shared-components/controls/urgencyTypes.json';
import languages from 'app/shared-components/controls/languages.json';
import races from 'app/shared-components/controls/races.json';
import DisplayUserHtml from 'app/shared-components/layout/DisplayUserHtml';



const ReferralDetailsInfo = (props) => {
  
  const {referral, showSummary}= props;
  if (!referral) return null;
  const isProvider = Boolean(referral?.provider);
  let location= "";
  if (referral.city) location= location + referral.city + ", "; 
  location= location + referral.stateProvince; 
  if (referral.postalCode) location= location + " " + referral.postalCode; 

 
  return (
	  <div className="flex flex-col space-y-20">
	  
	    {showSummary && (
			<>
			  <div className="mb-10">
	            <Typography color="secondary" className="font-semibold mb-4 text-20">{referral.summary}</Typography>
	          </div> 
	          <Divider style={{width:'100%'}} />
			</>
		)}
	      

          {referral.description && (
          <div className="flex items-center">
            <DisplayUserHtml id={referral.id} html={referral.description}  maxHeight="300px"/>
          </div>
          )}
        
          <div className="mb-10">
            <Typography color="secondary" className="font-semibold mb-4 text-15">Referral Type</Typography>
            <Typography>{getDisplayValue(referral.type, types)}</Typography>
          </div>
          
          
          <div className="mb-10">
            <Typography color="secondary" className="font-semibold mb-4 text-15">Client Type</Typography>
            <Typography>{getDisplayValue(referral.clientType, clientTypes)}</Typography>
          </div>
          
          <div className="mb-10">
            <Typography color="secondary" className="font-semibold mb-4 text-15">Referral Urgency</Typography>
            <Typography>{getDisplayValue(referral.urgency, urgencyTypes)}</Typography>
          </div>

        {(referral.availabilityWindows && referral.availabilityWindows.length > 0) &&
         <div className="mb-10">
            <Typography color="secondary" className="font-semibold mb-4 text-15">Client Availability</Typography>
            <Typography>{getListDisplayValue(referral.availabilityWindows, availabilityWindows) }</Typography>
          </div>
         }

         {(referral.specializations && referral.specializations.length > 0) &&
         <div className="mb-10">
            <Typography color="secondary" className="font-semibold mb-4 text-15">Conditions / Treatment Areas</Typography>
            <Typography>{getListDisplayValue(referral.specializations, conditions) }</Typography>
          </div>
         }
          
          {(referral.riskBehaviors && referral.riskBehaviors.length > 0) &&
          <div className="mb-10">
            <Typography color="secondary" className="font-semibold mb-4 text-15">High Risk Behaviors</Typography>
            <Typography>{getListDisplayValue(referral.riskBehaviors, riskBehaviors)}</Typography>
          </div>
          }
          
          {referral.gender &&
          <div className="mb-10">
            <Typography color="secondary" className="font-semibold mb-4 text-15">Client Gender</Typography>
            <Typography>{getDisplayValue(referral.gender, genders) }</Typography>
          </div>
          }
          
          {referral.familySupport &&
          <div className="mb-10">
            <Typography color="secondary" className="font-semibold mb-4 text-15">Family/Caregiver Support</Typography>
            <Typography>{getDisplayValue(referral.familySupport, familySupport)}</Typography>
          </div>
          }

          {referral.providerLanguage &&
              <div className="mb-10">
                  <Typography color="secondary" className="font-semibold mb-4 text-15">Preferred Provider Language</Typography>
                  <Typography>{getDisplayValue(referral.providerLanguage, languages)}</Typography>
              </div>
          }

          {referral.providerGender &&
          <div className="mb-10">
            <Typography color="secondary" className="font-semibold mb-4 text-15">Preferred Provider Gender</Typography>
            <Typography>{getDisplayValue(referral.providerGender, genders)}</Typography>
          </div>
          }
          
          {referral.providerAge &&                   
          <div className="mb-10">
            <Typography color="secondary" className="font-semibold mb-4 text-15">Preferred Provider Age</Typography>
            <Typography>{getDisplayValue(referral.providerAge, providerAges) }</Typography>
          </div>
          }

          {referral.providerRace &&
              <div className="mb-10">
                  <Typography color="secondary" className="font-semibold mb-4 text-15">Preferred Provider Race/Ethnicity</Typography>
                  <Typography>{getDisplayValue(referral.providerRace, races) }</Typography>
              </div>
          }
          
          {referral.treatmentLocation &&                 
         <div className="mb-10">
            <Typography color="secondary" className="font-semibold mb-4 text-15">Treatment Location</Typography>
            <Typography>{getDisplayValue(referral.treatmentLocation, treatmentLocations) }</Typography>
          </div>
          }
          
          <div className="mb-10">
            <Typography color="secondary" className="font-semibold mb-4 text-15">Private Pay?</Typography>
            <Typography>{referral.privatePay ? 'Yes' : 'No'}</Typography>
          </div>
          
          {!referral.privatePay && referral.insurance && (
		     <div className="mb-10">
            <Typography color="secondary" className="font-semibold mb-4 text-15">Insurance Plan</Typography>
            <Typography>{getDisplayValue(referral.insurance, insurance)}</Typography>
          </div>   
		      )}
		      
		      <div className="mb-10">
            <Typography color="secondary" className="font-semibold mb-4 text-15">Unlisted?</Typography>
            <Typography>{referral.hidden ? 'Yes' : 'No'}</Typography>
          </div>


          <div className="flex items-center">
            <FuseSvgIcon>heroicons-outline:location-marker</FuseSvgIcon>
            <div className="ml-24 leading-6">{location}</div>
          </div>
     

      </div>
  );
};

export default ReferralDetailsInfo;
